import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { LedgerTab } from '../components/history/LedgerTab';
import { OrdersTab } from '../components/history/OrdersTab';
import { TradesTab } from '../components/history/TradesTab';
import { PositionsTab } from '../components/history/PositionsTab';
import { Download } from 'lucide-react';
import { motion } from 'framer-motion';
type TabType = 'ledger' | 'orders' | 'trades' | 'positions';
export function HistoryPage() {
  const [activeTab, setActiveTab] = useState<TabType>('ledger');
  const tabs: {
    id: TabType;
    label: string;
  }[] = [{
    id: 'ledger',
    label: 'Ledger'
  }, {
    id: 'orders',
    label: 'Orders'
  }, {
    id: 'trades',
    label: 'Trades'
  }, {
    id: 'positions',
    label: 'Positions'
  }];
  const handleExport = () => {
    console.log('Export data for tab:', activeTab);
    // Export logic will be implemented based on active tab
  };
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-2414">
      <Sidebar data-id="element-2415" />

      <div className="flex-1 flex flex-col min-w-0 mesh-bg" data-id="element-2416">
        <Header data-id="element-2417" />

        <main className="flex-1 overflow-y-auto relative z-0" data-id="element-2418">
          {/* Page Header */}
          <div className="border-b border-border-subtle" data-id="element-2419">
            <div className="px-3 py-3 md:px-6 md:py-4" data-id="element-2420">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4" data-id="element-2421">
                <h1 className="text-xl md:text-2xl font-heading text-text-primary" data-id="element-2422">
                  Account History
                </h1>
                <button onClick={handleExport} className="flex items-center justify-center gap-2 px-4 py-2 min-h-[44px] w-full sm:w-auto bg-brand-purple/20 backdrop-blur-sm hover:bg-brand-purple/30 text-white rounded-xl transition-colors text-sm font-medium border border-[rgba(122,46,255,0.25)] border-t-[rgba(122,46,255,0.5)] hover:border-[rgba(122,46,255,0.35)] hover:border-t-[rgba(122,46,255,0.6)]" data-id="element-2423">
                  <Download size={16} data-id="element-2424" />
                  Export
                </button>
              </div>

              {/* Tabs */}
              <div className="flex items-center gap-1 overflow-x-auto pb-1 scrollbar-hide" data-id="element-2425">
                {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-1.5 text-sm font-ui rounded-lg transition-all whitespace-nowrap flex-shrink-0 ${activeTab === tab.id ? 'bg-background-elevated text-text-primary' : 'text-text-secondary hover:text-text-primary hover:bg-background-elevated/50'}`} data-id="element-2426">
                    {tab.label}
                  </button>)}
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="p-3 md:p-6" data-id="element-2427">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.35
          }} data-id="element-2428">
              {activeTab === 'ledger' && <LedgerTab data-id="element-2429" />}
              {activeTab === 'orders' && <OrdersTab data-id="element-2430" />}
              {activeTab === 'trades' && <TradesTab data-id="element-2431" />}
              {activeTab === 'positions' && <PositionsTab data-id="element-2432" />}
            </motion.div>
          </div>
        </main>
      </div>
    </div>;
}